module.exports = __webpack_public_path__ + "static/ui-6-57ab75a9f6583a5838b117747aac831a.png";